import { formatarNumero } from '@/lib/utils'

/**
 * Formata minutos em HH:mm aceitando valores negativos.
 *
 * `minutesToHours` de @acme/common recusa negativo (devolve '00:00'),
 * e subtração de horas é o caso normal da calculadora.
 *
 * @example formatarMinutos(240) // '04:00'
 * @example formatarMinutos(-60) // '-01:00'
 */
export const formatarMinutos = (minutos: number): string => {
    const total = Math.round(minutos)
    const sinal = total < 0 ? '-' : ''
    const absoluto = Math.abs(total)

    const horas = Math.floor(absoluto / 60)
    const resto = absoluto % 60

    return `${sinal}${String(horas).padStart(2, '0')}:${String(resto).padStart(2, '0')}`
}

/** Linha secundária do display: o mesmo valor em minutos. */
export const formatarTotalMinutos = (minutos: number): string =>
    `${formatarNumero(Math.round(minutos))} min`
